import { useModalSheet } from 'src/components/contexts/ModalSheetContext'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { TurboPickupLightningIcon } from 'src/components/Icons/TurboPickupLightningIcon'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

import { TurboPickupModal } from './TurboPickupModal'

export function TurboPickupButton() {
  const { pageData } = useGlobalContext()

  const { openModal, closeModal } = useModalSheet()
  const standardObject = getStandardObject(pageData) ?? {}

  const handleClick = () => {
    dispatchAmplitudeEvent({
      eventName: 'Fast Buy',
      eventData: {
        ...standardObject,
      },
    })

    openModal({
      content: <TurboPickupModal onClose={closeModal} />,
      header: { isVisible: false, component: undefined },
      variation: 'desktopInset',
      height: '100dvh',
    })
  }

  return (
    <button
      data-testid="turbo-pickup-button"
      className="flex items-center justify-center gap-1.5 h-9 w-9 restructure-small-desktop:w-auto restructure-small-desktop:px-4 bg-white border border-primaryBlue rounded-full text-primaryBlue text-sm font-medium hover:bg-turboPickupBadgeBg transition-colors whitespace-nowrap"
      onClick={handleClick}
      aria-label="Retirada turbo"
    >
      <TurboPickupLightningIcon className="text-turboPickupAction" />
      <span className="hidden restructure-small-desktop:inline">
        Retirada turbo
      </span>
    </button>
  )
}
